import React from "react"
import Layout from "../../../components/layout"
import Hero from "../../../components/olympo/hero"
import img from "../../../assets/images/heroOlympoUrbano.png"
import WrapperBlock from "../../../components/olympo/wrapperBlock"
// import Block1 from "../../../components/olympo/block1"
import Block1 from "../../../components/olympo/block1"
import ChasisCompatibles from "../../../components/olympo/chasisCompatibles"
import { OlympoBlock1 } from "../../../data/Olympo29"
import { OlympoBlock2 } from "../../../data/Olympo29"
import { OlympoBlock3 } from "../../../data/Olympo29"
import { OlympoBlock4 } from "../../../data/Olympo29"
import { OlympoBlock5 } from "../../../data/Olympo29"
const Olympo29 = () => {
  return (
    <Layout
      img={img}
      title="OLYMPO 2.9"
      description="Vehículo para el transporte URBANO de pasajeros. Carrocería LIVIANO, ELEGANTE E INNOVADOR."
    >
      <Hero
        img={img}
        title="OLYMPO 2.9"
        subtitle="Buses urbanos"
        text="
        <li>Vehículo para el transporte <b>URBANO</b> de pasajeros.</li><br/>
        <li>Carrocería <b>LIVIANO, ELEGANTE E INNOVADOR.</b></li>
        "
        crTitle1="Pasajeros sentados"
        crTitle2="Largo"
        crTitle3="Ancho"
        crTitle4="Altura"
        crTitle5="Chasis"
        crText1="27 (conf. 2 X 1)"
        crText2="9.00 m"
        crText3="2.20 m"
        crText4="2.90 m"
        crText5="Mitsubishi, Hyundai"
        chasisData={[
          { label: "NRO ASIENTOS", values: ["28", "28"] },
          { label: "NRO PASAJEROS", values: ["27", "27"] },
          { label: "LARGO", values: ["9 mtrs", "9 mtrs"] },
          { label: "ALTO", values: ["2.90 mtrs", "2.960 mtrs"] },
          { label: "ANCHO", values: ["2.20 mtrs", "2.20 mtrs"] },
        ]}
      />
      <ChasisCompatibles
        data={[
          { brand: "HYUNDAI", model: "BX8", pdf: "/pdf/HYUNDAI-FT-BX8.pdf" },
          { brand: "MITSUBISHI", model: "MF100", pdf: "/pdf/MITSUBISHI-FUSO-MF100.pdf" },
        ]}
      />
      <WrapperBlock>
      <Block1 subtitle="SALÓN DE PASAJEROS" data={OlympoBlock1}></Block1>
      <Block1 subtitle="CABINA DE CONDUCTOR" data={OlympoBlock2}></Block1>
      <Block1 subtitle="CONDUCCIÓN" data={OlympoBlock3}></Block1>
      <Block1 subtitle="EXTERIOR" data={OlympoBlock4}></Block1>
      <Block1
          title="CARACTERÍSTICAS OPCIONALES"
          color="gris"
          data={OlympoBlock5}
          backcolor='gris'
        ></Block1>
      </WrapperBlock>
    </Layout>
  )
}

export default Olympo29
